import { ConsumptionValueInputType } from '../../calculator.component';
import { HourlyConsumptionType } from './hourly-consumption-type';
import { MonthlyConsumptionType } from './monthly-consumption-type';
import { ConsumptionTypeInterface } from './consumption-type.interface';
import { MonthlyBillConsumptionType } from './monthly-bill-consumption-type';

export class ConsumptionTypeFactory {
  static getConsumptionTypeInstance(type: ConsumptionValueInputType): ConsumptionTypeInterface {
    switch (type) {
      case ConsumptionValueInputType.Hourly:
        return new HourlyConsumptionType();
      case ConsumptionValueInputType.MonthByMonth:
      case ConsumptionValueInputType.MonthlyAverage:
        return new MonthlyConsumptionType();
      case ConsumptionValueInputType.MonthlyBill:
        return new MonthlyBillConsumptionType();
    }
  }
}
